import { Injectable, signal } from '@angular/core';
import {ConnectionSide} from "@app/model-composer";
type ExternalUpdateClickedFn = (i: any) => any;

@Injectable({ providedIn: 'root' })
export class VestaBridgeService {
  private _vestaEl: any | null = null;
  private _externalUpdateClicked: ExternalUpdateClickedFn | null = null;
  readonly isAttached = signal(false);
  readonly hasExternalUpdateClicked = signal(false);
  private _lastHookSent: 'A' | 'B' | null = null;
  private _ignoreNextHookEvent = false;

  attach(vestaEl: any): void {
    this._vestaEl = vestaEl;
    this.isAttached.set(true);
    const direct = vestaEl?.cardinals?.externalUpdateClicked;
    if (typeof direct === 'function') {
      this.setExternalUpdateClicked((i: any) => direct.call(vestaEl.cardinals, i));
    }
  }

  detach(): void {
    this._vestaEl = null;
    this._externalUpdateClicked = null;
    this.isAttached.set(false);
    this.hasExternalUpdateClicked.set(false);
    this._lastHookSent = null;
    this._ignoreNextHookEvent = false;
  }

  setExternalUpdateClicked(fn: ExternalUpdateClickedFn): void {
    this._externalUpdateClicked = fn;
    this.hasExternalUpdateClicked.set(true);
  }

  shouldIgnoreNextHookEvent(): boolean {
    if (!this._ignoreNextHookEvent) return false;
    this._ignoreNextHookEvent = false;
    return true;
  }

  callExternalUpdateClicked(arg: any): void {
    if (!this._externalUpdateClicked) return;
    this._externalUpdateClicked(arg);
  }

  callExternalUpdateClickedForSide(side: ConnectionSide): void {
    if (!this._externalUpdateClicked) return;
    const hook: 'A' | 'B' = side === ConnectionSide.Left ? 'A' : 'B';
    if (this._lastHookSent === hook) return;
    this._lastHookSent = hook;
    this._ignoreNextHookEvent = true;
    this._externalUpdateClicked(hook);
  }
}
